
















import { defineComponent, computed } from '@nuxtjs/composition-api';
import { useTranslations } from '@vue-storefront/novulo';
import usePromotionsDrawer from '~/hooks/usePromotionsDrawer';
import useUrlFormatter from '~/hooks/useUrlFormatter';

export default defineComponent({
  setup() {
    const { translate } = useTranslations();

    const { isPromotionsDrawerOpen, closePromotionsDrawer, activePromotion } =
      usePromotionsDrawer();
    const formatUrl = useUrlFormatter();

    const promotionHtml = computed(() => {
      if (!activePromotion.value) return '';
      let htmlContent = '';
      if (activePromotion.value.short_description)
        htmlContent += activePromotion.value.short_description;
      if (activePromotion.value.long_description)
        htmlContent += activePromotion.value.long_description;
      return htmlContent;
    });

    const promotionUrl = computed(() => {
      if (!activePromotion.value?.external_link) return null;
      return formatUrl(activePromotion.value.external_link);
    });

    const handleCloseDrawer = () => {
      closePromotionsDrawer();
    };

    return {
      isPromotionsDrawerOpen,
      promotionHtml,
      handleCloseDrawer,
      promotionUrl,
      translate
    };
  }
});
